import { FILE_SIZE_EXCEEDS_LIMIT, MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB } from '@/shared/config';

export const RECORD_PDF_EXTENSION_MESSAGE = 'Selecione um arquivo no formato PDF.';
export const RECORD_PDF_SINGLE_FILE_MESSAGE = 'Selecione apenas um arquivo.';
export const RECORD_PDF_SIZE_MESSAGE = FILE_SIZE_EXCEEDS_LIMIT(MAX_FILE_SIZE_MB);

export type RecordPdfSelection = { file: File } | { error: string };

// Only the extension is checked here; the server reads the content and refuses a renamed file.
export function selectRecordPdf(files: ArrayLike<File>): RecordPdfSelection | null {
  if (files.length === 0) return null;
  if (files.length > 1) return { error: RECORD_PDF_SINGLE_FILE_MESSAGE };

  const file = files[0];
  if (!file.name.toLowerCase().endsWith('.pdf')) return { error: RECORD_PDF_EXTENSION_MESSAGE };
  if (file.size > MAX_FILE_SIZE_BYTES) return { error: RECORD_PDF_SIZE_MESSAGE };

  return { file };
}
